if (!customElements.get('product-swatches-group')) {
  class ProductSwatchesGroup extends HTMLElement {
    constructor() {
      super();

      this.currentColorLabel = this.querySelector('.product-swatches-group__size-label');
      this.currentColorLabelValue = this.currentColorLabel.textContent;
      this.swatcheItems = this.querySelectorAll('.product-swatches-group__item');

      // this.addEventListener('click', (e) => {
      //   if (e.target.classList.contains('product-card__list-item')) {
      //     e.preventDefault();
      //     const productUrl = e.target.getAttribute('data-product-url');
      //     const chosenSize = document.querySelector('.product-form__fieldset input:checked');
      //     const targetVariantsData = JSON.parse(e.target.closest('.product-swatches-group__item').querySelector('script').textContent);
      //     let variantId = []
      //     if(chosenSize) {
      //       variantId = targetVariantsData.filter((variant) => variant.title === chosenSize.value );
      //     }
      //     variantId.length > 0 && chosenSize ? this.url = `${productUrl}?variant=${variantId[0].id}` : this.url = e.target.href;
      //
      //     if (!this.url) return
      //     this.getNewPdp();
      //   }
      // })

      this.swatcheItems.forEach(swatch => {
        swatch.addEventListener('mouseenter', (e) => {
          this.currentColorLabel.textContent = e.target.querySelector('a')?.title ? e.target.querySelector('a')?.title : this.currentColorLabelValue
        })
      })

      this.swatcheItems.forEach(swatch => {
        swatch.addEventListener('mouseleave', () => {
          this.currentColorLabel.textContent = this.currentColorLabelValue
        })
      })
    }

    // getNewPdp() {
    //   fetch(this.url)
    //     .then((response) => response.text())
    //     .then((responseText) => {
    //       const html = new DOMParser().parseFromString(responseText, 'text/html');
    //       if (!html) return
    //
    //       this.updateContent(html)
    //     });
    // }

    // updateContent(html) {
    //   const pdpContent = document.querySelector('#MainContent');
    //   const newPDPContent = html.querySelector('#MainContent');
    //   //const stickyBar = document.querySelector('.product-sticky-bar');
    //
    //   // if (stickyBar && stickyBar.getAttribute('aria-hidden') === 'false') {
    //   //   newPDPContent.querySelector('.product-sticky-bar').setAttribute('aria-hidden', 'false');
    //   //   newPDPContent.querySelector('.product__details').classList.add('sticky-bar-active');
    //   // }
    //
    //   if (pdpContent && newPDPContent) {
    //     pdpContent.innerHTML = newPDPContent.innerHTML;
    //     //if (window.okeWidgetApi) window.okeWidgetApi.initAllWidgets();
    //     //initVideo();
    //     window.history.replaceState(null, '', this.url);
    //   }
    //
    //   //checkStickyHeader();
    // }
  }
  customElements.define('product-swatches-group', ProductSwatchesGroup);
}
